<template>
	<header id="page-topbar">
		<div class="navbar-header">
			<div class="d-flex">
				<div class="navbar-brand-box text-center">
					<a href="/" class="logo logo-dark">
						<span class="logo-sm">
							<img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
						</span>
						<span class="logo-lg">
							<img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
						</span>
					</a>
					<a href="/" class="logo logo-light">
						<span class="logo-sm">
							<img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
						</span>
						<span class="logo-lg">
							<img src="https://ihextar.s3.ap-southeast-1.amazonaws.com/hextar-removebg-preview.png" alt width="40%" />
						</span>
					</a>
				</div>
				<button @click="toggleMenu" type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect" id="vertical-menu-btn">
					<i class="ri-menu-2-line align-middle"></i>
				</button>
			</div>
			<div class="d-flex">
				<b-dropdown variant="white" right toggle-class="header-item">
					<template v-slot:button-content>
						<img
							class
							:src="current_language?.flag"
							alt="Header Language"
							height="16"
						/>
					</template>
					<b-dropdown-item
						class="notify-item"
						v-for="(entry, i) in languages"
						:key="`Lang${i}`"
						:value="entry"
						@click="setLanguage(entry)"
						:link-class="{ 'active': entry === current_language }"
					>
						<img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
						<span class="align-middle">{{ entry.title }}</span>
					</b-dropdown-item>
				</b-dropdown>
				<b-dropdown right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown">
					<template v-slot:button-content>
						<img class="rounded-circle header-profile-user"
							src="https://getbase.s3.ap-southeast-1.amazonaws.com/default_profile_image.jpg"
							alt="Header Avatar"
							style="margin: 5px;"
						/>
						<span class="d-none d-xl-inline-flex flex-column align-items-start align-middle ml-1 user-identity">
							<span>{{ name }}</span>
							<b-badge v-if="isSuperadmin" variant="info" class="superadmin-badge">Super Admin</b-badge>
						</span>
						<i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
					</template>
					<router-link class="dropdown-item" :to="{ name: 'Profile' }">
						<i class="ri-user-line align-middle mr-1"></i>
						{{ $t('module.profile') }}
					</router-link>
					<div class="dropdown-divider"></div>
					<a
						class="dropdown-item text-danger cursor-pointer"
						v-on:click="handleLogout"
					>
						<i class="mdi mdi-logout mr-1 text-danger"></i>
						{{ $t('module.logout') }}
					</a>
				</b-dropdown>
			</div>
		</div>
	</header>
</template>
<script>
import i18n from "@/i18n";
import { sessionHelper } from '@/utils';

export default {
	data() {
		return {
			name: sessionHelper.getUserName(),
			userType: sessionHelper.getUserType(),
			languages: [
				{
					flag: require("@/assets/images/flags/us.jpg"),
					language: "en",
					title: "English"
				},
				{
					flag: require("@/assets/images/flags/chaina.png"),
					language: "zh",
					title: "Chinese"
				},
				{
					flag: require("@/assets/images/flags/melayu.png"),
					language: "ms",
					title: "Bahasa Melayu"
				},
			],
			current_language: null,
		};
	},
	async created() {
		this.current_language = this.languages[0];
	},
	computed: {
		isSuperadmin() {
			const user = this.$store.state.api.auth.user?.user;
			return user
				? [true, 1, "1"].includes(user.isSuperadmin ?? user.is_superadmin)
				: sessionHelper.isSuperadminUser();
		},
	},
	methods: {
		toggleMenu() {
			this.$parent.toggleMenu();
		},
		toggleRightSidebar() {
			this.$parent.toggleRightSidebar();
		},
		setLanguage(locale) {
			i18n.locale = locale.language;
			this.current_language = locale;
		},
		async handleLogout() {
			
			const namespace = this.userType == 'api' ? 'api/auth' : 'app/auth';

			this.$store.dispatch(`${namespace}/logout`);
		},
	},
};
</script>
<style lang="scss" scoped>
	.user-identity { line-height: 1.3; }
	.superadmin-badge { margin-top: 3px; font-size: 10px; font-weight: 600; background-color: #6f42c1; color: #fff; }
	.notify-item {
		.active {
			color: #16181b;
			background-color: #f8f9fa;
		}
	}
	.selected-text span {
		color: #007bff;
		font-weight: bold;
	}
</style>